import { motion } from 'framer-motion'
import Badge from '../ui/Badge'
import Card from '../ui/Card'
import { formatCompactNumber } from './analyticsTypes'

interface MetricCardProps {
  label: string
  value: number | string | null | undefined
  delta?: { label: string; positive: boolean } | null
  detail?: string
  loading?: boolean
}

export default function MetricCard({ label, value, delta, detail, loading = false }: MetricCardProps) {
  const displayValue = typeof value === 'number' ? formatCompactNumber(value) : value ?? '—'

  return (
    <Card className="relative min-h-[8.5rem] overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" />
      <p className="text-xs uppercase tracking-[0.22em] text-gray-500">{label}</p>
      {loading ? (
        <div className="mt-5 h-9 w-28 stat-skeleton" />
      ) : (
        <motion.p
          className="mt-4 text-3xl font-bold tracking-tight text-white tabular-nums"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {displayValue}
        </motion.p>
      )}
      <div className="mt-4 flex items-center justify-between gap-3">
        <p className="truncate text-xs text-gray-500">{detail ?? 'Current range'}</p>
        {delta && (
          <Badge variant={delta.positive ? 'success' : 'warning'} size="sm">
            {delta.label}
          </Badge>
        )}
      </div>
    </Card>
  )
}
